export enum SPACE_PERMISSIONS {
  SPACE_VIEW = 'SPACE_VIEW',
  SPACE_WRITE = 'SPACE_WRITE',
}
